import React from 'react'

export default function RightArrow() {
    return (
        <svg width="22" height="27" viewBox="0 0 22 27" fill="none">
            <g filter='url(#filter0_d)'>
                <path d="M6 19.2375L11.725 13.5L6 7.7625L7.7625 6L15.2625 13.5L7.7625 21L6 19.2375Z" fill="white" />
            </g>
            <defs>
                <filter id="filter0_d" x="0" y="0" width="21.2625" height="27" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    )
}